import React from 'react';
import { Navigate, Outlet,useNavigate } from 'react-router-dom';
import { getUser,signout,validateToken } from './Service/LoginService';


function PrivateRoutes() {
    const token = getUser();
    const navigate=useNavigate();
    const isTokenValid = (token) => {
        validateToken(token).then(response => {
            if(response.data=== false){
                signout();
                navigate("/");
            }
        }).catch(err => {
            console.log('error catched Token might expired ' + err.response);
            signout();
            navigate("/");
          })

        return token && token;
    }

    return (
        (token && isTokenValid(token)) ? <Outlet /> : <Navigate to='/' />
    )
}

export default PrivateRoutes